<template>
    <div class="yjzs_container">
        <!-- 分类胶囊 -->
        <div class="yjzs_tabs">
            <div
                class="yjzs_tab"
                :class="{ active: tabTypeId === item.typeId }"
                v-for="item in yjzsInfo"
                :key="item.typeId"
                @click="changeType(item.typeId)">
                {{ item.typeName }}
            </div>
        </div>

        <!-- 画廊展墙 -->
        <div class="yjzs_wall" v-if="showData.length > 0">
            <div
                class="yjzs_item reveal-init"
                v-reveal="idx * 80"
                v-for="(item, idx) in showData"
                :key="item.achievementid"
                @click="showDetails(item)">
                <div class="yjzs_item_media">
                    <el-image :src="item.achievementfaceimg" fit="cover">
                        <div slot="error" class="image-slot">
                            <i class="el-icon-picture-outline"></i>
                        </div>
                    </el-image>
                </div>
                <!-- 常态：底部名称条 -->
                <div class="yjzs_item_bar">
                    <span class="yjzs_item_name">{{ item.achievementname }}</span>
                    <span class="yjzs_item_arrow">→</span>
                </div>
                <!-- 悬停：绿幕升起 -->
                <div class="yjzs_item_overlay">
                    <div class="yjzs_item_name_big">{{ item.achievementname }}</div>
                    <div class="yjzs_item_more">查看详情 →</div>
                </div>
            </div>
        </div>
        <div class="yjzs_empty reveal-init" v-reveal v-else>暂无数据</div>

        <!-- 分页 -->
        <div class="yjzs_pager">
            <el-pagination
                layout="prev, pager, next"
                @current-change="pageChanged"
                :current-page="pageInfo.currentPage"
                :total="pageInfo.totals"
                :page-size="pageInfo.pageSize">
            </el-pagination>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      tabTypeId: 0,
      yjzsInfo: [
        { typeName: '设计', typeId: 0 },
        { typeName: '施工', typeId: 1 },
        { typeName: '监理', typeId: 2 },
        { typeName: '资讯', typeId: 3 },
        { typeName: '科研', typeId: 4 }
      ],
      showData: [],
      pageInfo: {
        currentPage: 1,
        pageSize: 8,
        totals: 0
      }
    }
  },
  directives: {
    // 轻量进场指令：默认可见 + 渐显（渐进增强，永不藏死内容）。
    // 视口内 rAF 同步揭示；离屏由 IntersectionObserver 滚动到位时揭示。
    reveal: {
      inserted (el, binding) {
        const delay = binding.value || 0
        el.style.setProperty('--reveal-delay', delay + 'ms')
        const vh = window.innerHeight || document.documentElement.clientHeight
        const rect = el.getBoundingClientRect()
        if (rect.top < vh && rect.bottom > 0) {
          requestAnimationFrame(() => el.classList.add('reveal-in'))
        } else {
          const io = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                el.classList.add('reveal-in')
                io.unobserve(el)
              }
            })
          }, { threshold: 0.1, rootMargin: '0px 0px -8% 0px' })
          io.observe(el)
          el.__revealIO__ = io
        }
      },
      unbind (el) {
        if (el.__revealIO__) el.__revealIO__.disconnect()
      }
    }
  },
  methods: {
    changeType (typeId) {
      this.tabTypeId = typeId
      this.pageInfo = {
        currentPage: 1,
        pageSize: 8,
        totals: 0
      }
      this.getYjInfo(typeId)
      // 切分类复位滚动，保证新内容从顶部进入视口
      window.scrollTo(0, 0)
    },
    getYjInfo (typeId) {
      this.$http.post('/admin/getAchievementByPageType/' + typeId, this.pageInfo).then(res => {
        this.showData = res.data.achievements
        this.pageInfo.totals = res.data.totals
      })
    },
    showDetails (data) {
      window.sessionStorage.setItem('jdalDetails', JSON.stringify(data))
      this.$router.push('jdalDetails')
    },
    pageChanged (currentPage) {
      this.pageInfo.currentPage = currentPage
      this.getYjInfo(this.tabTypeId)
      window.scrollTo(0, 0)
    }
  },
  created () {
    this.changeType(0)
  }
}
</script>

<style lang="less" scoped>
.yjzs_container {
    --ss-green-800: #163a2b;
    --ss-green: #2e6b4f;
    --ss-green-200: #e3ece5;
    --ss-sand: #f7f5f0;
    --ss-gold: #c9a86a;

    width: 100%;
    background: #fff;
    border-radius: 8px;
    padding: 0 0 20px;
    overflow: hidden;
}

/* 顶部分类胶囊（与 xwzx/gyss 全站一致） */
.yjzs_tabs {
    display: flex;
    gap: 10px;
    padding: 18px 24px;
    border-bottom: 1px solid #ece8df;
}
.yjzs_tab {
    padding: 8px 22px;
    border-radius: 999px;
    font-size: 15px;
    color: #5b6b62;
    cursor: pointer;
    border: 1px solid transparent;
    transition: all .3s cubic-bezier(.22, .61, .36, 1);
    white-space: nowrap;
}
.yjzs_tab:hover {
    color: var(--ss-green);
    background: #eef3f0;
}
.yjzs_tab.active {
    background: var(--ss-green);
    color: #fff;
    box-shadow: 0 4px 12px rgba(22, 58, 43, .18);
}

/* 画廊展墙 */
.yjzs_wall {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 18px;
    padding: 26px 24px 6px;
}
.yjzs_item {
    position: relative;
    border-radius: 12px;
    overflow: hidden;
    cursor: pointer;
    aspect-ratio: 4 / 3;
    background: var(--ss-green-200);
    box-shadow: 0 6px 18px rgba(22, 58, 43, .10);
    transition: box-shadow .4s cubic-bezier(.22, .61, .36,1), transform .4s cubic-bezier(.22, .61, .36, 1);
}
.yjzs_item:hover {
    box-shadow: 0 16px 36px rgba(22, 58, 43, .20);
    transform: translateY(-4px);
}
.yjzs_item_media {
    position: absolute;
    inset: 0;
}
.yjzs_item_media ::v-deep .el-image {
    width: 100%;
    height: 100%;
}
.yjzs_item_media ::v-deep .el-image__inner {
    transition: transform .8s cubic-bezier(.22, .61, .36, 1);
}
.yjzs_item:hover .yjzs_item_media ::v-deep .el-image__inner {
    transform: scale(1.08);
}
.yjzs_item_media ::v-deep .image-slot {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--ss-green-200);
    color: #9db3a6;
    font-size: 26px;
}

/* 常态：底部名称条 */
.yjzs_item_bar {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 9px 14px;
    background: rgba(22, 58, 43, .88);
    transition: opacity .35s ease, transform .35s ease;
}
.yjzs_item_name {
    flex: 1;
    min-width: 0;
    font-size: 14px;
    font-weight: 500;
    color: var(--ss-sand);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.yjzs_item_arrow {
    flex: none;
    color: var(--ss-gold);
    font-size: 13px;
    transition: transform .35s cubic-bezier(.22, .61, .36, 1);
}
.yjzs_item:hover .yjzs_item_arrow {
    transform: translateX(4px);
}

/* 悬停：绿幕升起 */
.yjzs_item_overlay {
    position: absolute;
    inset: 0;
    z-index: 3;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 18px;
    background: rgba(14, 43, 32, .90);
    transform: translateY(100%);
    transition: transform .45s cubic-bezier(.22, .61, .36, 1);
}
.yjzs_item:hover .yjzs_item_overlay {
    transform: translateY(0);
}
.yjzs_item_name_big {
    max-width: 100%;
    font-size: 16px;
    font-weight: 500;
    color: var(--ss-sand);
    text-align: center;
    line-height: 1.5;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.yjzs_item_more {
    font-size: 13px;
    color: var(--ss-gold);
    letter-spacing: 1px;
}

/* 空态 */
.yjzs_empty {
    padding: 70px 0;
    text-align: center;
    color: #9aa79f;
    font-size: 15px;
}

/* 分页 */
.yjzs_pager {
    padding: 22px 0 6px;
    text-align: center;
}
.yjzs_pager ::v-deep .el-pager li {
    border-radius: 8px;
    font-weight: 500;
    color: var(--ss-green-800);
    transition: all .25s ease;
}
.yjzs_pager ::v-deep .el-pager li:hover {
    color: var(--ss-green);
}
.yjzs_pager ::v-deep .el-pager li.active {
    background: var(--ss-green);
    color: #fff;
}
.yjzs_pager ::v-deep .btn-prev,
.yjzs_pager ::v-deep .btn-next {
    border-radius: 8px;
    color: var(--ss-green);
}

/* 进场动画：默认可见 + 渐显（渐进增强，回调不触发也不会隐藏） */
.reveal-init { }
.reveal-init.reveal-in {
    animation: yjzsReveal .7s cubic-bezier(.22, .61, .36, 1) both;
    animation-delay: var(--reveal-delay, 0ms);
}
@keyframes yjzsReveal {
    from { opacity: 0; transform: translateY(26px); }
    to   { opacity: 1; transform: none; }
}

/* 响应式：桌面 4 列 / 平板 2 列 / 手机 1 列 */
@media screen and (max-width: 1024px) {
    .yjzs_wall {
        grid-template-columns: repeat(2, 1fr);
        gap: 14px;
        padding: 20px 16px 4px;
    }
    .yjzs_tabs {
        padding: 14px 16px;
        gap: 8px;
        overflow-x: auto;
    }
    .yjzs_tab {
        padding: 7px 16px;
        font-size: 14px;
    }
}
@media screen and (max-width: 560px) {
    .yjzs_wall {
        grid-template-columns: 1fr;
        gap: 12px;
        padding: 16px 12px 4px;
    }
    .yjzs_tabs {
        padding: 12px;
    }
    .yjzs_tab {
        padding: 6px 13px;
        font-size: 13px;
    }
    .yjzs_item_name_big {
        font-size: 15px;
    }
}
</style>
